<template>
  <div class="modal-wrapper">
    <div class="modal-container modal-container--large">
      <div class="modal-header">
        <span class="title title--1 title--white">
          {{ $t('filter.date.title') }}
        </span>
        <div class="modal-close" @click="closeModal">
          <i class="fas fa-times"></i>
        </div>
      </div>
      <div class="modal-body date-filter date-filter--d-flex">
        <p class="date-filter__text">
          {{ $t('filter.date.from') }}
        </p>
        <label>
          <input v-model="beginDateFilter" type="date" />
        </label>
        <p class="date-filter__text">{{ $t('filter.date.to') }}</p>
        <label>
          <input v-model="endDateFilter" type="date" />
        </label>
      </div>
      <div class="modal-footer">
        <button class="button button--danger" @click="deleteFilters">
          {{ $t('filter.date.erase') }}
        </button>
        <button class="button button--valid" @click="filter">
          {{ $t('filter.date.filter') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      beginDateFilter: '',
      endDateFilter: '',
    };
  },
  methods: {
    closeModal() {
      this.$emit('closeModal');
    },
    deleteFilters() {
      this.beginDateFilter = '';
      this.endDateFilter = '';
      this.$emit('eraseDateFilter');
      this.closeModal();
    },
    filter() {
      if (this.beginDateFilter && this.endDateFilter)
        this.$emit('filter', [this.beginDateFilter, this.endDateFilter]);
      this.closeModal();
    },
  },
};
</script>
